/**
 * What the Add-a-team search shows for what was typed (console spec §5.3):
 * every match, marked when the team is already entered in the chosen
 * division, plus a "Create" row unless a match already has that exact name.
 * Pure, so the rows can be tested without a debounce or a request.
 */
export interface TeamMatch {
  id: string;
  name: string;
  ageGroup: string;
  classification: string;
}

export type SearchRow =
  | { kind: "team"; team: TeamMatch; alreadyEntered: boolean }
  | { kind: "create"; name: string };

export function searchRows(
  matches: TeamMatch[],
  typed: string,
  enteredTeamIds: ReadonlySet<string>,
): SearchRow[] {
  const name = typed.trim();
  const rows: SearchRow[] = matches.map((team) => ({
    kind: "team",
    team,
    alreadyEntered: enteredTeamIds.has(team.id),
  }));
  const exact = matches.some((m) => m.name.trim().toLowerCase() === name.toLowerCase());
  if (name && !exact) rows.push({ kind: "create", name });
  return rows;
}
